define.alias("shared/utils/country-list", "calendar/utils/country-list");